export enum ProgressCircleColor {
  BLACK = 'black',
  ICE = 'nordic-blue-900',
  GREY = 'nordic-blue-900',
  GOLD = 'loyalty-gold-dark',
  BLUE = 'nordic-blue-900',
}
